var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubsidiaryLgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 219,
    viewBox: "0 0 238 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_971_2889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.764 78.9644H186.94C186.94 78.9644 191.777 65.7256 199.226 65.7256C206.675 65.7256 209.014 74.8637 209.014 74.8637C209.014 74.8637 214.039 69.9005 218.168 69.9005C222.298 69.9005 225.868 76.4628 225.868 76.4628C225.868 76.4628 231.721 72.9332 235.764 78.9644Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.348 27.1115H175.533C175.533 27.1115 180.632 19.7153 184.659 19.7153C188.686 19.7153 189.866 24.6442 189.866 24.6442C189.866 24.6442 192.718 22.3597 195.325 22.7537C197.931 23.1478 198.348 27.1115 198.348 27.1115Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6852 60.831H2.2417C2.2417 60.831 8.32759 47.2267 14.8299 46.3757C21.3321 45.5247 24.4635 56.4847 24.4635 56.4847C24.4635 56.4847 28.6614 52.6125 31.9411 52.6125C35.2207 52.6125 37.7931 57.7127 37.7931 57.7127C37.7931 57.7127 44.4209 54.2173 46.6852 60.831Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0367 10.0004H49.0122C49.0122 10.0004 54.1855 0.148441 59.7638 -5.29049e-05C65.342 -0.148547 68.3194 7.46462 68.3194 7.46462C68.3194 7.46462 77.0005 0.468273 79.0367 10.0004Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0247 78.0793H43.7593C43.7593 78.0793 47.2386 71.4256 51.0144 71.3285C54.7903 71.2314 56.7752 76.3659 56.7752 76.3659C56.7752 76.3659 62.6501 71.6483 64.0247 78.0793Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.96 88.9878H157.246V218.714H181.96V88.9878Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.882 93.197H161.079V98.1487H165.882V93.197Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.031 93.197H167.228V98.1487H172.031V93.197Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.882 101.61H161.079V106.562H165.882V101.61Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.031 101.61H167.228V106.562H172.031V101.61Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.882 110.017H161.079V114.969H165.882V110.017Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.031 110.017H167.228V114.969H172.031V110.017Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.882 118.43H161.079V123.381H165.882V118.43Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.031 118.43H167.228V123.381H172.031V118.43Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.882 126.837H161.079V131.788H165.882V126.837Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.031 126.837H167.228V131.788H172.031V126.837Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.882 135.249H161.079V140.201H165.882V135.249Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.031 135.249H167.228V140.201H172.031V135.249Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.882 143.656H161.079V148.608H165.882V143.656Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.031 143.656H167.228V148.608H172.031V143.656Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.882 152.069H161.079V157.021H165.882V152.069Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.031 152.069H167.228V157.021H172.031V152.069Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.882 160.476H161.079V165.428H165.882V160.476Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.031 160.476H167.228V165.428H172.031V160.476Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.882 168.889H161.079V173.841H165.882V168.889Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.031 168.889H167.228V173.841H172.031V168.889Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.882 177.296H161.079V182.248H165.882V177.296Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.031 177.296H167.228V182.248H172.031V177.296Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.882 185.709H161.079V190.66H165.882V185.709Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.031 185.709H167.228V190.66H172.031V185.709Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.882 194.116H161.079V199.067H165.882V194.116Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.031 194.116H167.228V199.067H172.031V194.116Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.882 202.529H161.079V207.48H165.882V202.529Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.32 207.48H178.122V202.529H173.32V207.48Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.32 199.073H178.122V194.122H173.32V199.073Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.32 190.66H178.122V185.709H173.32V190.66Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.32 182.253H178.122V177.302H173.32V182.253Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.32 173.841H178.122V168.889H173.32V173.841Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.32 165.434H178.122V160.482H173.32V165.434Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.32 157.021H178.122V152.069H173.32V157.021Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.32 148.614H178.122V143.662H173.32V148.614Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.32 140.201H178.122V135.249H173.32V140.201Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.32 131.794H178.122V126.842H173.32V131.794Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.32 123.381H178.122V118.43H173.32V123.381Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.32 114.974H178.122V110.023H173.32V114.974Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.32 106.562H178.122V101.61H173.32V106.562Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.32 98.1545H178.122V93.2028H173.32V98.1545Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.031 202.529H167.228V207.48H172.031V202.529Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.444 88.9878H181.96V218.714H201.444V88.9878Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.467 207.48H199.437V202.529H195.467V207.48Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.391 207.48H194.36V202.529H190.391V207.48Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.467 199.073H199.437V194.122H195.467V199.073Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.391 199.073H194.36V194.122H190.391V199.073Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.467 190.66H199.437V185.709H195.467V190.66Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.391 190.66H194.36V185.709H190.391V190.66Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.467 182.253H199.437V177.302H195.467V182.253Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.391 182.253H194.36V177.302H190.391V182.253Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.467 173.841H199.437V168.889H195.467V173.841Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.391 173.841H194.36V168.889H190.391V173.841Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.467 165.434H199.437V160.482H195.467V165.434Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.391 165.434H194.36V160.482H190.391V165.434Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.467 157.021H199.437V152.069H195.467V157.021Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.391 157.021H194.36V152.069H190.391V157.021Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.467 148.614H199.437V143.662H195.467V148.614Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.391 148.614H194.36V143.662H190.391V148.614Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.467 140.201H199.437V135.249H195.467V140.201Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.391 140.201H194.36V135.249H190.391V140.201Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.467 131.794H199.437V126.842H195.467V131.794Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.391 131.794H194.36V126.842H190.391V131.794Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.467 123.381H199.437V118.43H195.467V123.381Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.391 123.381H194.36V118.43H190.391V123.381Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.467 114.974H199.437V110.023H195.467V114.974Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.391 114.974H194.36V110.023H190.391V114.974Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.467 106.562H199.437V101.61H195.467V106.562Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.391 106.562H194.36V101.61H190.391V106.562Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.467 98.1545H199.437V93.2028H195.467V98.1545Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.33 93.197H185.36V98.1487H189.33V93.197Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.33 101.61H185.36V106.562H189.33V101.61Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.33 110.017H185.36V114.969H189.33V110.017Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.33 118.43H185.36V123.381H189.33V118.43Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.33 126.837H185.36V131.788H189.33V126.837Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.33 135.249H185.36V140.201H189.33V135.249Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.33 143.656H185.36V148.608H189.33V143.656Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.33 152.069H185.36V157.021H189.33V152.069Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.33 160.476H185.36V165.428H189.33V160.476Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.33 168.889H185.36V173.841H189.33V168.889Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.33 177.296H185.36V182.248H189.33V177.296Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.33 185.709H185.36V190.66H189.33V185.709Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.33 194.116H185.36V199.067H189.33V194.116Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.33 202.529H185.36V207.48H189.33V202.529Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.391 98.1545H194.36V93.2028H190.391V98.1545Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4728 86.155H30.6919V218.714H56.4728V86.155Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4783 83.5164H30.0757V86.155H56.4783V83.5164Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6367 90.0444H33.0244V218.714H35.6367V90.0444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2627 90.0444H37.6504V218.714H40.2627V90.0444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8882 90.0444H42.2759V218.714H44.8882V90.0444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5195 90.0444H46.9072V218.714H49.5195V90.0444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1455 90.0444H51.5332V218.714H54.1455V90.0444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6367 93.3799H33.0244V98.5886H35.6367V93.3799Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2627 93.3799H37.6504V98.5886H40.2627V93.3799Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8882 93.3799H42.2759V98.5886H44.8882V93.3799Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5195 93.3799H46.9072V98.5886H49.5195V93.3799Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1455 93.3799H51.5332V98.5886H54.1455V93.3799Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6367 101.85H33.0244V107.058H35.6367V101.85Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2627 101.85H37.6504V107.058H40.2627V101.85Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8882 101.85H42.2759V107.058H44.8882V101.85Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5195 101.85H46.9072V107.058H49.5195V101.85Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1455 101.85H51.5332V107.058H54.1455V101.85Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6367 110.32H33.0244V115.528H35.6367V110.32Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2627 110.32H37.6504V115.528H40.2627V110.32Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8882 110.32H42.2759V115.528H44.8882V110.32Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5195 110.32H46.9072V115.528H49.5195V110.32Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1455 110.32H51.5332V115.528H54.1455V110.32Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6367 118.789H33.0244V123.998H35.6367V118.789Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2627 118.789H37.6504V123.998H40.2627V118.789Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8882 118.789H42.2759V123.998H44.8882V118.789Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5195 118.789H46.9072V123.998H49.5195V118.789Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1455 118.789H51.5332V123.998H54.1455V118.789Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6367 127.254H33.0244V132.462H35.6367V127.254Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2627 127.254H37.6504V132.462H40.2627V127.254Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8882 127.254H42.2759V132.462H44.8882V127.254Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5195 127.254H46.9072V132.462H49.5195V127.254Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1455 127.254H51.5332V132.462H54.1455V127.254Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6367 135.723H33.0244V140.932H35.6367V135.723Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2627 135.723H37.6504V140.932H40.2627V135.723Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8882 135.723H42.2759V140.932H44.8882V135.723Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5195 135.723H46.9072V140.932H49.5195V135.723Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1455 135.723H51.5332V140.932H54.1455V135.723Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6367 144.193H33.0244V149.402H35.6367V144.193Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2627 144.193H37.6504V149.402H40.2627V144.193Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8882 144.193H42.2759V149.402H44.8882V144.193Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5195 144.193H46.9072V149.402H49.5195V144.193Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1455 144.193H51.5332V149.402H54.1455V144.193Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6367 152.663H33.0244V157.872H35.6367V152.663Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2627 152.663H37.6504V157.872H40.2627V152.663Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8882 152.663H42.2759V157.872H44.8882V152.663Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5195 152.663H46.9072V157.872H49.5195V152.663Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1455 152.663H51.5332V157.872H54.1455V152.663Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6367 161.133H33.0244V166.342H35.6367V161.133Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2627 161.133H37.6504V166.342H40.2627V161.133Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8882 161.133H42.2759V166.342H44.8882V161.133Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5195 161.133H46.9072V166.342H49.5195V161.133Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1455 161.133H51.5332V166.342H54.1455V161.133Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6367 169.597H33.0244V174.806H35.6367V169.597Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2627 169.597H37.6504V174.806H40.2627V169.597Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8882 169.597H42.2759V174.806H44.8882V169.597Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5195 169.597H46.9072V174.806H49.5195V169.597Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1455 169.597H51.5332V174.806H54.1455V169.597Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6367 178.067H33.0244V183.276H35.6367V178.067Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2627 178.067H37.6504V183.276H40.2627V178.067Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8882 178.067H42.2759V183.276H44.8882V178.067Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5195 178.067H46.9072V183.276H49.5195V178.067Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1455 178.067H51.5332V183.276H54.1455V178.067Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6367 186.537H33.0244V191.746H35.6367V186.537Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2627 186.537H37.6504V191.746H40.2627V186.537Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8882 186.537H42.2759V191.746H44.8882V186.537Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5195 186.537H46.9072V191.746H49.5195V186.537Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1455 186.537H51.5332V191.746H54.1455V186.537Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6367 195.007H33.0244V200.216H35.6367V195.007Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2627 195.007H37.6504V200.216H40.2627V195.007Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8882 195.007H42.2759V200.216H44.8882V195.007Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5195 195.007H46.9072V200.216H49.5195V195.007Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1455 195.007H51.5332V200.216H54.1455V195.007Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6367 203.477H33.0244V218.72H35.6367V203.477Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2627 203.477H37.6504V218.72H40.2627V203.477Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8882 203.477H42.2759V218.72H44.8882V203.477Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5195 203.477H46.9072V218.72H49.5195V203.477Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1455 203.477H51.5332V218.72H54.1455V203.477Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0308 86.155H56.4785V218.714H73.0308V86.155Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7494 83.5164H56.4785V86.155H73.7494V83.5164Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.418 90.0444H58.8057V218.714H61.418V90.0444Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0493 90.0444H63.437V218.714H66.0493V90.0444Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6748 90.0444H68.0625V218.714H70.6748V90.0444Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.418 93.3799H58.8057V98.5886H61.418V93.3799Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0493 93.3799H63.437V98.5886H66.0493V93.3799Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6748 93.3799H68.0625V98.5886H70.6748V93.3799Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.418 101.85H58.8057V107.058H61.418V101.85Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0493 101.85H63.437V107.058H66.0493V101.85Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6748 101.85H68.0625V107.058H70.6748V101.85Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.418 110.32H58.8057V115.528H61.418V110.32Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0493 110.32H63.437V115.528H66.0493V110.32Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6748 110.32H68.0625V115.528H70.6748V110.32Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.418 118.789H58.8057V123.998H61.418V118.789Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0493 118.789H63.437V123.998H66.0493V118.789Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6748 118.789H68.0625V123.998H70.6748V118.789Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.418 127.254H58.8057V132.462H61.418V127.254Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0493 127.254H63.437V132.462H66.0493V127.254Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6748 127.254H68.0625V132.462H70.6748V127.254Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.418 135.723H58.8057V140.932H61.418V135.723Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0493 135.723H63.437V140.932H66.0493V135.723Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6748 135.723H68.0625V140.932H70.6748V135.723Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.418 144.193H58.8057V149.402H61.418V144.193Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0493 144.193H63.437V149.402H66.0493V144.193Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6748 144.193H68.0625V149.402H70.6748V144.193Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.418 152.663H58.8057V157.872H61.418V152.663Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0493 152.663H63.437V157.872H66.0493V152.663Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6748 152.663H68.0625V157.872H70.6748V152.663Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.418 161.133H58.8057V166.342H61.418V161.133Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0493 161.133H63.437V166.342H66.0493V161.133Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6748 161.133H68.0625V166.342H70.6748V161.133Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.418 169.597H58.8057V174.806H61.418V169.597Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0493 169.597H63.437V174.806H66.0493V169.597Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6748 169.597H68.0625V174.806H70.6748V169.597Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.418 178.067H58.8057V183.276H61.418V178.067Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0493 178.067H63.437V183.276H66.0493V178.067Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6748 178.067H68.0625V183.276H70.6748V178.067Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.418 186.537H58.8057V191.746H61.418V186.537Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0493 186.537H63.437V191.746H66.0493V186.537Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6748 186.537H68.0625V191.746H70.6748V186.537Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.418 195.007H58.8057V200.216H61.418V195.007Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0493 195.007H63.437V200.216H66.0493V195.007Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6748 195.007H68.0625V200.216H70.6748V195.007Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.418 203.477H58.8057V218.72H61.418V203.477Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0493 203.477H63.437V218.72H66.0493V203.477Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6748 203.477H68.0625V218.72H70.6748V203.477Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3626 125.854H1.91064V218.714H26.3626V125.854Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3628 119.698H5.39014V125.854H26.3628V119.698Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6817 129.07H4.59131V198.485H23.6817V129.07Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6817 135.695H4.59131V137.334H23.6817V135.695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6817 142.491H4.59131V144.13H23.6817V142.491Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6817 149.288H4.59131V150.927H23.6817V149.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6817 156.079H4.59131V157.718H23.6817V156.079Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6817 162.875H4.59131V164.514H23.6817V162.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6817 169.671H4.59131V171.311H23.6817V169.671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6817 176.462H4.59131V178.101H23.6817V176.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6817 183.259H4.59131V184.898H23.6817V183.259Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6817 190.055H4.59131V191.694H23.6817V190.055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6817 196.846H4.59131V198.485H23.6817V196.846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6773 125.854H26.3628V218.714H41.6773V125.854Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3787 119.698H26.3628V125.854H39.3787V119.698Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2514 129.07H28.4731V198.485H40.2514V129.07Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2514 135.695H28.4731V137.334H40.2514V135.695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2514 142.491H28.4731V144.13H40.2514V142.491Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2514 149.288H28.4731V150.927H40.2514V149.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2514 156.079H28.4731V157.718H40.2514V156.079Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2514 162.875H28.4731V164.514H40.2514V162.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2514 169.671H28.4731V171.311H40.2514V169.671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2514 176.462H28.4731V178.101H40.2514V176.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2514 183.259H28.4731V184.898H40.2514V183.259Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2514 190.055H28.4731V191.694H40.2514V190.055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2514 196.846H28.4731V198.485H40.2514V196.846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.932 127.425H202.871V142.874H215.932V127.425Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.208 127.425H215.926V143.439H224.208V127.425Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.762 134.244H216.542V143.439H224.762V134.244Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.889 134.244H224.762V143.439H229.889V134.244Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.978 141.863H197.863V218.714H218.978V141.863Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.915 145.17H200.275V147.889H206.915V145.17Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.407 145.17H208.768V147.889H215.407V145.17Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.915 149.785H200.275V152.503H206.915V149.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.407 149.785H208.768V152.503H215.407V149.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.915 154.394H200.275V157.112H206.915V154.394Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.407 154.394H208.768V157.112H215.407V154.394Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.915 159.008H200.275V161.727H206.915V159.008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.407 159.008H208.768V161.727H215.407V159.008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.915 163.617H200.275V166.336H206.915V163.617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.407 163.617H208.768V166.336H215.407V163.617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.915 168.232H200.275V170.951H206.915V168.232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.407 168.232H208.768V170.951H215.407V168.232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.915 172.847H200.275V175.565H206.915V172.847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.407 172.847H208.768V175.565H215.407V172.847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.915 177.456H200.275V180.174H206.915V177.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.407 177.456H208.768V180.174H215.407V177.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.915 182.071H200.275V184.789H206.915V182.071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.407 182.071H208.768V184.789H215.407V182.071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.915 186.685H200.275V189.404H206.915V186.685Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.407 186.685H208.768V189.404H215.407V186.685Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.915 191.294H200.275V194.013H206.915V191.294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.407 191.294H208.768V194.013H215.407V191.294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.915 195.909H200.275V198.628H206.915V195.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.407 195.909H208.768V198.628H215.407V195.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.915 200.524H200.275V203.242H206.915V200.524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.407 200.524H208.768V203.242H215.407V200.524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.915 205.133H200.275V207.851H206.915V205.133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.407 205.133H208.768V207.851H215.407V205.133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.089 141.863H218.978V218.714H236.089V141.863Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.925 207.852H234.378V205.133H228.925V207.852Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.944 207.852H227.396V205.133H221.944V207.852Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.925 203.237H234.378V200.518H228.925V203.237Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.944 203.237H227.396V200.518H221.944V203.237Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.925 198.628H234.378V195.909H228.925V198.628Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.944 198.628H227.396V195.909H221.944V198.628Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.925 194.013H234.378V191.294H228.925V194.013Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.944 194.013H227.396V191.294H221.944V194.013Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.925 189.398H234.378V186.68H228.925V189.398Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.944 189.398H227.396V186.68H221.944V189.398Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.925 184.789H234.378V182.071H228.925V184.789Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.944 184.789H227.396V182.071H221.944V184.789Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.925 180.18H234.378V177.462H228.925V180.18Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.944 180.18H227.396V177.462H221.944V180.18Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.925 175.56H234.378V172.841H228.925V175.56Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.944 175.56H227.396V172.841H221.944V175.56Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.925 170.951H234.378V168.232H228.925V170.951Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.944 170.951H227.396V168.232H221.944V170.951Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.925 166.342H234.378V163.623H228.925V166.342Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.944 166.342H227.396V163.623H221.944V166.342Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.925 161.721H234.378V159.003H228.925V161.721Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.944 161.721H227.396V159.003H221.944V161.721Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.925 157.112H234.378V154.394H228.925V157.112Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.944 157.112H227.396V154.394H221.944V157.112Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.925 152.498H234.378V149.779H228.925V152.498Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.944 152.498H227.396V149.779H221.944V152.498Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.925 147.888H234.378V145.17H228.925V147.888Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.944 147.888H227.396V145.17H221.944V147.888Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.702 168.638H117.793V218.714H142.702V168.638Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.121 172.973H121.712V176.04H126.121V172.973Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.121 179.529H121.712V182.596H126.121V179.529Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.121 186.08H121.712V189.147H126.121V186.08Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.121 192.631H121.712V195.698H126.121V192.631Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.121 199.188H121.712V202.254H126.121V199.188Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.121 205.738H121.712V208.805H126.121V205.738Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.121 212.289H121.712V215.356H126.121V212.289Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.458 172.973H128.049V176.04H132.458V172.973Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.458 179.529H128.049V182.596H132.458V179.529Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.458 186.08H128.049V189.147H132.458V186.08Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.458 192.631H128.049V195.698H132.458V192.631Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.458 199.188H128.049V202.254H132.458V199.188Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.458 205.738H128.049V208.805H132.458V205.738Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.458 212.289H128.049V215.356H132.458V212.289Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.784 172.973H134.375V176.04H138.784V172.973Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.784 179.529H134.375V182.596H138.784V179.529Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.784 186.08H134.375V189.147H138.784V186.08Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.784 192.631H134.375V195.698H138.784V192.631Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.784 199.188H134.375V202.254H138.784V199.188Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.784 205.738H134.375V208.805H138.784V205.738Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.784 212.289H134.375V215.356H138.784V212.289Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.696 163.423H126.115V168.643H142.696V163.423Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.702 160.191H132.19V163.423H142.702V160.191Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.178 168.638H142.702V218.714H160.178V168.638Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.8 214.871H158.387V211.804H154.8V214.871Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.8 208.32H158.387V205.253H154.8V208.32Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.8 201.763H158.387V198.696H154.8V201.763Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.8 195.207H158.387V192.14H154.8V195.207Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.8 188.662H158.387V185.595H154.8V188.662Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.8 182.105H158.387V179.038H154.8V182.105Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.8 175.548H158.387V172.481H154.8V175.548Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.637 214.871H153.225V211.804H149.637V214.871Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.637 208.32H153.225V205.253H149.637V208.32Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.637 201.763H153.225V198.696H149.637V201.763Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.637 195.207H153.225V192.14H149.637V195.207Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.637 188.662H153.225V185.595H149.637V188.662Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.637 182.105H153.225V179.038H149.637V182.105Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.637 175.548H153.225V172.481H149.637V175.548Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.493 214.871H148.081V211.804H144.493V214.871Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.493 208.32H148.081V205.253H144.493V208.32Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.493 201.763H148.081V198.696H144.493V201.763Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.493 195.207H148.081V192.14H144.493V195.207Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.493 188.662H148.081V185.595H144.493V188.662Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.493 182.105H148.081V179.038H144.493V182.105Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.493 175.548H148.081V172.481H144.493V175.548Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.531 163.423H142.702V168.643H157.531V163.423Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.738 160.191H142.702V163.423H150.738V160.191Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.386 98.834H170.741V214.568H208.386V98.834Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.238 87.1887H180.073V98.8284H208.238V87.1887Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.824 88.9878H182.417V97.035H184.824V88.9878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.039 88.9878H186.632V97.035H189.039V88.9878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.254 88.9878H190.847V97.035H193.254V88.9878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.469 88.9878H195.062V97.035H197.469V88.9878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.678 88.9878H199.271V97.035H201.678V88.9878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.893 88.9878H203.486V97.035H205.893V88.9878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.054 87.1887H208.244V98.8284H221.054V87.1887Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.082 88.9878H210.035V97.035H212.082V88.9878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.67 88.9878H213.622V97.035H215.67V88.9878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.252 88.9878H217.204V97.035H219.252V88.9878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.403 98.834H208.244V214.568H227.403V98.834Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.394 106.801H178.447V117.453H185.394V106.801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.534 106.801H192.587V117.453H199.534V106.801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.394 123.593H178.447V134.244H185.394V123.593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.534 123.593H192.587V134.244H199.534V123.593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.394 140.378H178.447V151.03H185.394V140.378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.534 140.378H192.587V151.03H199.534V140.378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.394 157.164H178.447V167.815H185.394V157.164Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.534 157.164H192.587V167.815H199.534V157.164Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.394 173.955H178.447V184.606H185.394V173.955Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.534 173.955H192.587V184.606H199.534V173.955Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.394 190.74H178.447V201.392H185.394V190.74Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.534 190.74H192.587V201.392H199.534V190.74Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.755 106.801H211.763V117.453H215.755V106.801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.877 106.801H219.885V117.453H223.877V106.801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.755 123.593H211.763V134.244H215.755V123.593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.877 123.593H219.885V134.244H223.877V123.593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.755 140.378H211.763V151.03H215.755V140.378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.877 140.378H219.885V151.03H223.877V140.378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.755 157.164H211.763V167.815H215.755V157.164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.877 157.164H219.885V167.815H223.877V157.164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.755 173.955H211.763V184.606H215.755V173.955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.877 173.955H219.885V184.606H223.877V173.955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.755 190.74H211.763V201.392H215.755V190.74Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.877 190.74H219.885V201.392H223.877V190.74Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.633 66.0913H88.499V214.562H108.633V66.0913Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.633 74.4067H88.499V75.9659H108.633V74.4067Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2773 80.5579H90.5698V89.239H94.2773V80.5579Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2773 91.5122H90.5698V100.193H94.2773V91.5122Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2773 102.461H90.5698V111.142H94.2773V102.461Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2773 113.409H90.5698V122.091H94.2773V113.409Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2773 124.364H90.5698V133.045H94.2773V124.364Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2773 135.318H90.5698V143.999H94.2773V135.318Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2773 146.261H90.5698V154.942H94.2773V146.261Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2773 157.215H90.5698V165.896H94.2773V157.215Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2773 168.169H90.5698V176.851H94.2773V168.169Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2773 179.112H90.5698V187.793H94.2773V179.112Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2773 190.066H90.5698V198.748H94.2773V190.066Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2773 201.021H90.5698V209.702H94.2773V201.021Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2773 80.5579H90.5698V89.239H94.2773V80.5579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2773 91.5122H90.5698V100.193H94.2773V91.5122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2773 102.461H90.5698V111.142H94.2773V102.461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2773 113.409H90.5698V122.091H94.2773V113.409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2773 124.364H90.5698V133.045H94.2773V124.364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2773 135.318H90.5698V143.999H94.2773V135.318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2773 146.261H90.5698V154.942H94.2773V146.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2773 157.215H90.5698V165.896H94.2773V157.215Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2773 168.169H90.5698V176.851H94.2773V168.169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2773 179.112H90.5698V187.793H94.2773V179.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2773 190.066H90.5698V198.748H94.2773V190.066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2773 201.021H90.5698V209.702H94.2773V201.021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.42 80.5579H96.7124V89.239H100.42V80.5579Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.42 91.5122H96.7124V100.193H100.42V91.5122Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.42 102.461H96.7124V111.142H100.42V102.461Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.42 113.409H96.7124V122.091H100.42V113.409Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.42 124.364H96.7124V133.045H100.42V124.364Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.42 135.318H96.7124V143.999H100.42V135.318Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.42 146.261H96.7124V154.942H100.42V146.261Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.42 157.215H96.7124V165.896H100.42V157.215Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.42 168.169H96.7124V176.851H100.42V168.169Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.42 179.112H96.7124V187.793H100.42V179.112Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.42 190.066H96.7124V198.748H100.42V190.066Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.42 201.021H96.7124V209.702H100.42V201.021Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.42 80.5579H96.7124V89.239H100.42V80.5579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.42 91.5122H96.7124V100.193H100.42V91.5122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.42 102.461H96.7124V111.142H100.42V102.461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.42 113.409H96.7124V122.091H100.42V113.409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.42 124.364H96.7124V133.045H100.42V124.364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.42 135.318H96.7124V143.999H100.42V135.318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.42 146.261H96.7124V154.942H100.42V146.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.42 157.215H96.7124V165.896H100.42V157.215Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.42 168.169H96.7124V176.851H100.42V168.169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.42 179.112H96.7124V187.793H100.42V179.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.42 190.066H96.7124V198.748H100.42V190.066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.42 201.021H96.7124V209.702H100.42V201.021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.557 80.5579H102.85V89.239H106.557V80.5579Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.557 91.5122H102.85V100.193H106.557V91.5122Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.557 102.461H102.85V111.142H106.557V102.461Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.557 113.409H102.85V122.091H106.557V113.409Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.557 124.364H102.85V133.045H106.557V124.364Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.557 135.318H102.85V143.999H106.557V135.318Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.557 146.261H102.85V154.942H106.557V146.261Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.557 157.215H102.85V165.896H106.557V157.215Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.557 168.169H102.85V176.851H106.557V168.169Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.557 179.112H102.85V187.793H106.557V179.112Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.557 190.066H102.85V198.748H106.557V190.066Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.557 201.021H102.85V209.702H106.557V201.021Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.557 80.5579H102.85V89.239H106.557V80.5579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.557 91.5122H102.85V100.193H106.557V91.5122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.557 102.461H102.85V111.142H106.557V102.461Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.557 113.409H102.85V122.091H106.557V113.409Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.557 124.364H102.85V133.045H106.557V124.364Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.557 135.318H102.85V143.999H106.557V135.318Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.557 146.261H102.85V154.942H106.557V146.261Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.557 157.215H102.85V165.896H106.557V157.215Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.557 168.169H102.85V176.851H106.557V168.169Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.557 179.112H102.85V187.793H106.557V179.112Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.557 190.066H102.85V198.748H106.557V190.066Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.557 201.021H102.85V209.702H106.557V201.021Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4992 66.0913H54.0771V214.562H88.4992V66.0913Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4992 74.4067H54.0771V75.9659H88.4992V74.4067Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.499 57.7527H66.3457V66.0912H88.499V57.7527Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4935 66.0913H98.9028V57.7528H88.4935V66.0913Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.785 80.5579H57.7676V89.239H63.785V80.5579Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.785 91.5122H57.7676V100.193H63.785V91.5122Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.785 102.461H57.7676V111.142H63.785V102.461Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.785 113.409H57.7676V122.091H63.785V113.409Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.785 124.364H57.7676V133.045H63.785V124.364Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.785 135.318H57.7676V143.999H63.785V135.318Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.785 146.261H57.7676V154.942H63.785V146.261Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.785 157.215H57.7676V165.896H63.785V157.215Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.785 168.169H57.7676V176.851H63.785V168.169Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.785 179.112H57.7676V187.793H63.785V179.112Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.785 190.066H57.7676V198.748H63.785V190.066Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.785 201.021H57.7676V209.702H63.785V201.021Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.785 80.5579H57.7676V89.239H63.785V80.5579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.785 91.5122H57.7676V100.193H63.785V91.5122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.785 102.461H57.7676V111.142H63.785V102.461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.785 113.409H57.7676V122.091H63.785V113.409Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.785 124.364H57.7676V133.045H63.785V124.364Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.785 135.318H57.7676V143.999H63.785V135.318Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.785 146.261H57.7676V154.942H63.785V146.261Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.785 157.215H57.7676V165.896H63.785V157.215Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.785 168.169H57.7676V176.851H63.785V168.169Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.785 179.112H57.7676V187.793H63.785V179.112Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.785 190.066H57.7676V198.748H63.785V190.066Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.785 201.021H57.7676V209.702H63.785V201.021Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7494 80.5579H67.7319V89.239H73.7494V80.5579Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7494 91.5122H67.7319V100.193H73.7494V91.5122Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7494 102.461H67.7319V111.142H73.7494V102.461Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7494 113.409H67.7319V122.091H73.7494V113.409Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7494 124.364H67.7319V133.045H73.7494V124.364Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7494 135.318H67.7319V143.999H73.7494V135.318Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7494 146.261H67.7319V154.942H73.7494V146.261Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7494 157.215H67.7319V165.896H73.7494V157.215Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7494 168.169H67.7319V176.851H73.7494V168.169Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7494 179.112H67.7319V187.793H73.7494V179.112Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7494 190.066H67.7319V198.748H73.7494V190.066Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7494 201.021H67.7319V209.702H73.7494V201.021Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7494 80.5579H67.7319V89.239H73.7494V80.5579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7494 91.5122H67.7319V100.193H73.7494V91.5122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7494 102.461H67.7319V111.142H73.7494V102.461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7494 113.409H67.7319V122.091H73.7494V113.409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7494 124.364H67.7319V133.045H73.7494V124.364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7494 135.318H67.7319V143.999H73.7494V135.318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7494 146.261H67.7319V154.942H73.7494V146.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7494 157.215H67.7319V165.896H73.7494V157.215Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7494 168.169H67.7319V176.851H73.7494V168.169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7494 179.112H67.7319V187.793H73.7494V179.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7494 190.066H67.7319V198.748H73.7494V190.066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7494 201.021H67.7319V209.702H73.7494V201.021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7196 80.5579H77.7021V89.239H83.7196V80.5579Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7196 91.5122H77.7021V100.193H83.7196V91.5122Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7196 102.461H77.7021V111.142H83.7196V102.461Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7196 113.409H77.7021V122.091H83.7196V113.409Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7196 124.364H77.7021V133.045H83.7196V124.364Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7196 135.318H77.7021V143.999H83.7196V135.318Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7196 146.261H77.7021V154.942H83.7196V146.261Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7196 157.215H77.7021V165.896H83.7196V157.215Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7196 168.169H77.7021V176.851H83.7196V168.169Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7196 179.112H77.7021V187.793H83.7196V179.112Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7196 190.066H77.7021V198.748H83.7196V190.066Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7196 201.021H77.7021V209.702H83.7196V201.021Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7196 80.5579H77.7021V89.239H83.7196V80.5579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7196 91.5122H77.7021V100.193H83.7196V91.5122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7196 102.461H77.7021V111.142H83.7196V102.461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7196 113.409H77.7021V122.091H83.7196V113.409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7196 124.364H77.7021V133.045H83.7196V124.364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7196 135.318H77.7021V143.999H83.7196V135.318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7196 146.261H77.7021V154.942H83.7196V146.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7196 157.215H77.7021V165.896H83.7196V157.215Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7196 168.169H77.7021V176.851H83.7196V168.169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7196 179.112H77.7021V187.793H83.7196V179.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7196 190.066H77.7021V198.748H83.7196V190.066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7196 201.021H77.7021V209.702H83.7196V201.021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0157 214.562H13.729V128.853L41.0157 111.142V214.562Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5076 214.562H16.7974V131.251L37.5076 117.813V214.562Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M37.5076 214.562H16.7974V131.251L37.5076 117.813V214.562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5075 132.691H19.1699V133.353H37.5075V132.691Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5075 138.105H19.1699V138.768H37.5075V138.105Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5075 143.52H19.1699V144.182H37.5075V143.52Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5075 148.934H19.1699V149.596H37.5075V148.934Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5075 154.348H19.1699V155.011H37.5075V154.348Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5075 159.762H19.1699V160.425H37.5075V159.762Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5075 165.177H19.1699V165.839H37.5075V165.177Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5075 170.591H19.1699V171.254H37.5075V170.591Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5075 176.005H19.1699V176.668H37.5075V176.005Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5075 181.42H19.1699V182.082H37.5075V181.42Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5075 186.834H19.1699V187.496H37.5075V186.834Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5075 192.248H19.1699V192.911H37.5075V192.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5075 197.663H19.1699V198.325H37.5075V197.663Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5075 203.077H19.1699V203.739H37.5075V203.077Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5075 208.491H19.1699V209.154H37.5075V208.491Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5075 213.906H19.1699V214.568H37.5075V213.906Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0107 126.397L28.0107 214.562H28.6724L28.6724 126.397H28.0107Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.5076 117.807V120.794L19.1701 132.691V214.562H16.7974V131.246L37.5076 117.807Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M37.5076 117.807V120.794L19.1701 132.691V214.562H16.7974V131.246L37.5076 117.807Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0569 111.142H41.0156V214.562H65.0569V111.142Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M65.0569 111.142H41.0156V214.562H65.0569V111.142Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.7238 117.807H43.3481V120.149H62.7238V117.807Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7238 123.113H43.3481V125.455H62.7238V123.113Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7238 128.419H43.3481V130.76H62.7238V128.419Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7238 133.719H43.3481V136.06H62.7238V133.719Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7238 139.025H43.3481V141.366H62.7238V139.025Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7238 144.325H43.3481V146.666H62.7238V144.325Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7238 149.631H43.3481V151.972H62.7238V149.631Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7238 154.936H43.3481V157.278H62.7238V154.936Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7238 160.236H43.3481V162.578H62.7238V160.236Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7238 165.542H43.3481V167.884H62.7238V165.542Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7238 170.848H43.3481V173.19H62.7238V170.848Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7238 176.148H43.3481V178.49H62.7238V176.148Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7238 181.454H43.3481V183.795H62.7238V181.454Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7238 186.754H43.3481V189.096H62.7238V186.754Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7238 192.06H43.3481V194.401H62.7238V192.06Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7238 197.366H43.3481V199.707H62.7238V197.366Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7238 202.666H43.3481V205.007H62.7238V202.666Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7238 207.971H43.3481V210.313H62.7238V207.971Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164.456 105.065H142.827V214.568H164.456V105.065Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.456 105.065H142.827V214.568H164.456V105.065Z",
    fill: "#391FB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.822 105.065H165.745V101.478H142.822V105.065Z",
    fill: "#5627FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.821 101.479H162.26V95.8757H142.821V101.479Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.821 101.479H162.26V95.8757H142.821V101.479Z",
    fill: "#391FB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.822 95.8699H157.691V83.5106H142.822V95.8699Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.822 95.8699H157.691V83.5106H142.822V95.8699Z",
    fill: "#391FB5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.83 109.211H144.898V120.731H147.83V109.211Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.83 124.906H144.898V136.426H147.83V124.906Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.83 140.595H144.898V152.115H147.83V140.595Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.83 156.284H144.898V167.804H147.83V156.284Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.83 171.973H144.898V183.493H147.83V171.973Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.83 187.668H144.898V199.187H147.83V187.668Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.678 109.211H149.746V120.731H152.678V109.211Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.678 124.906H149.746V136.426H152.678V124.906Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.678 140.595H149.746V152.115H152.678V140.595Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.678 156.284H149.746V167.804H152.678V156.284Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.678 171.973H149.746V183.493H152.678V171.973Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.678 187.668H149.746V199.187H152.678V187.668Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.531 109.211H154.6V120.731H157.531V109.211Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.531 124.906H154.6V136.426H157.531V124.906Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.531 140.595H154.6V152.115H157.531V140.595Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.531 156.284H154.6V167.804H157.531V156.284Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.531 171.973H154.6V183.493H157.531V171.973Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.531 187.668H154.6V199.187H157.531V187.668Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.379 109.211H159.448V120.731H162.379V109.211Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.379 124.906H159.448V136.426H162.379V124.906Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.379 140.595H159.448V152.115H162.379V140.595Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.379 156.284H159.448V167.804H162.379V156.284Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.379 171.973H159.448V183.493H162.379V171.973Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.379 187.668H159.448V199.187H162.379V187.668Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M142.822 105.065H98.4863V214.568H142.822V105.065Z",
    fill: "#5627FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.822 95.8699H100.608V101.473H142.822V95.8699Z",
    fill: "#5627FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.822 83.5164H111.058V95.8756H142.822V83.5164Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.822 83.5164H111.058V95.8756H142.822V83.5164Z",
    fill: "#5627FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.821 101.473H97.1572V105.059H142.821V101.473Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.821 101.473H97.1572V105.059H142.821V101.473Z",
    fill: "#391FB5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.742 109.211H102.724V120.731H108.742V109.211Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.742 124.906H102.724V136.426H108.742V124.906Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.742 140.595H102.724V152.115H108.742V140.595Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.742 156.284H102.724V167.804H108.742V156.284Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.742 171.973H102.724V183.493H108.742V171.973Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.742 187.668H102.724V199.187H108.742V187.668Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.689 109.211H112.671V120.731H118.689V109.211Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.689 124.906H112.671V136.426H118.689V124.906Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.689 140.595H112.671V152.115H118.689V140.595Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.689 156.284H112.671V167.804H118.689V156.284Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.689 171.973H112.671V183.493H118.689V171.973Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.689 187.668H112.671V199.187H118.689V187.668Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.637 109.211H122.619V120.731H128.637V109.211Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.637 124.906H122.619V136.426H128.637V124.906Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.637 140.595H122.619V152.115H128.637V140.595Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.637 156.284H122.619V167.804H128.637V156.284Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.637 171.973H122.619V183.493H128.637V171.973Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.637 187.668H122.619V199.187H128.637V187.668Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.584 109.211H132.566V120.731H138.584V109.211Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.584 124.906H132.566V136.426H138.584V124.906Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.584 140.595H132.566V152.115H138.584V140.595Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.584 156.284H132.566V167.804H138.584V156.284Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.584 171.973H132.566V183.493H138.584V171.973Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.584 187.668H132.566V199.187H138.584V187.668Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M128.636 203.711H112.671V214.562H128.636V203.711Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.831 152.121H187.202V214.562H208.831V152.121Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.831 152.121H187.202V214.562H208.831V152.121Z",
    fill: "#391FB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.197 152.121H210.12V148.534H187.197V152.121Z",
    fill: "#5627FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.197 148.534H206.635V142.931H187.197V148.534Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.197 148.534H206.635V142.931H187.197V148.534Z",
    fill: "#391FB5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.205 156.273H189.273V167.792H192.205V156.273Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.205 171.962H189.273V183.481H192.205V171.962Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.205 187.656H189.273V199.176H192.205V187.656Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.059 156.273H194.127V167.792H197.059V156.273Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.059 171.962H194.127V183.481H197.059V171.962Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.059 187.656H194.127V199.176H197.059V187.656Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.907 156.273H198.975V167.792H201.907V156.273Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.907 171.962H198.975V183.481H201.907V171.962Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.907 187.656H198.975V199.176H201.907V187.656Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.755 156.273H203.823V167.792H206.755V156.273Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.755 171.962H203.823V183.481H206.755V171.962Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.755 187.656H203.823V199.176H206.755V187.656Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M187.197 152.121H142.861V214.562H187.197V152.121Z",
    fill: "#5627FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.202 142.931H144.989V148.534H187.202V142.931Z",
    fill: "#5627FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.202 148.534H141.538V152.121H187.202V148.534Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.202 148.534H141.538V152.121H187.202V148.534Z",
    fill: "#391FB5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.122 156.273H147.105V167.792H153.122V156.273Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.122 171.962H147.105V183.481H153.122V171.962Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.122 187.656H147.105V199.176H153.122V187.656Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.064 156.273H157.047V167.792H163.064V156.273Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.064 171.962H157.047V183.481H163.064V171.962Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.064 187.656H157.047V199.176H163.064V187.656Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.012 156.273H166.994V167.792H173.012V156.273Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.012 171.962H166.994V183.481H173.012V171.962Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.012 187.656H166.994V199.176H173.012V187.656Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.959 156.273H176.941V167.792H182.959V156.273Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.959 171.962H176.941V183.481H182.959V171.962Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.959 187.656H176.941V199.176H182.959V187.656Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M169.886 63.8809C169.591 63.7316 169.286 63.6018 168.974 63.4925C168.653 63.3691 168.317 63.2903 167.976 63.2584C167.872 63.2543 167.768 63.2658 167.667 63.2926L167.571 63.3383L167.514 63.384L167.405 63.4697C167.276 63.5862 167.154 63.7102 167.04 63.8409C166.818 64.0922 166.618 64.3549 166.418 64.6234L166.664 64.5377C166.33 64.4451 165.991 64.3727 165.648 64.3207C165.472 64.3004 165.295 64.2889 165.118 64.2864H164.833C164.787 64.2864 164.736 64.2864 164.684 64.3264C164.631 64.3464 164.579 64.3713 164.53 64.4006C164.379 64.5072 164.244 64.6362 164.131 64.7833C164.022 64.9176 163.921 65.0588 163.829 65.2059C163.649 65.4983 163.49 65.8038 163.355 66.1197C163.572 65.857 163.783 65.5943 164.011 65.343C164.118 65.218 164.232 65.0998 164.354 64.9889C164.459 64.8804 164.578 64.7863 164.707 64.709C164.836 64.6673 164.972 64.6537 165.107 64.6691C165.265 64.6819 165.423 64.7029 165.58 64.7319C165.899 64.789 166.224 64.869 166.538 64.9546L166.698 65.0003L166.789 64.869C166.972 64.6062 167.171 64.3492 167.36 64.0979C167.462 63.9723 167.565 63.8523 167.667 63.7438L167.747 63.6696L167.782 63.641C167.837 63.6209 167.894 63.6093 167.953 63.6068C168.269 63.6071 168.584 63.6377 168.894 63.6981C169.242 63.7552 169.561 63.8238 169.886 63.8809Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.293 73.6015C165.904 73.2914 165.494 73.0089 165.066 72.7562C164.631 72.4845 164.161 72.2731 163.669 72.128C163.519 72.0869 163.362 72.0734 163.207 72.088C163.154 72.0966 163.103 72.11 163.053 72.128L162.95 72.1737L162.768 72.2707C162.547 72.4034 162.334 72.5484 162.129 72.7048C161.724 73.0132 161.353 73.3388 160.988 73.6757L161.376 73.6243C160.914 73.3849 160.436 73.1787 159.944 73.0075C159.692 72.9229 159.435 72.8542 159.174 72.8019C159.036 72.7701 158.894 72.751 158.752 72.7448C158.674 72.7394 158.596 72.7394 158.518 72.7448C158.437 72.7604 158.357 72.7813 158.279 72.8076C158.021 72.9207 157.783 73.0729 157.572 73.2588C157.372 73.4272 157.181 73.6064 157.001 73.7957C156.652 74.1687 156.332 74.5677 156.043 74.9893C156.442 74.6695 156.824 74.3439 157.229 74.047C157.429 73.8927 157.629 73.75 157.834 73.6186C158.023 73.4906 158.228 73.3888 158.444 73.3159C158.636 73.2958 158.83 73.3152 159.015 73.373C159.246 73.4357 159.473 73.5139 159.693 73.6072C160.144 73.7842 160.6 73.9956 161.039 74.2126L161.256 74.3211L161.427 74.1612C161.77 73.8242 162.14 73.5044 162.5 73.196C162.682 73.0408 162.872 72.8958 163.07 72.7619C163.113 72.7311 163.159 72.7043 163.207 72.682L163.264 72.642H163.292C163.381 72.6244 163.472 72.6244 163.561 72.642C164.023 72.732 164.476 72.8678 164.912 73.0475C165.409 73.2245 165.831 73.4187 166.293 73.6015Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.905 51.1161C66.6391 50.9167 66.3588 50.7373 66.0665 50.5792C65.7719 50.4076 65.4553 50.2769 65.1254 50.1908C65.0216 50.1727 64.9155 50.1727 64.8117 50.1908C64.7782 50.1958 64.7456 50.2054 64.7148 50.2194L64.6463 50.2537C64.6045 50.2731 64.5645 50.296 64.5265 50.3222C64.38 50.4119 64.2407 50.5131 64.1102 50.6249C63.8478 50.8362 63.6082 51.0647 63.363 51.2988L63.6196 51.2531C63.3076 51.1049 62.9855 50.979 62.6557 50.8762C62.4858 50.8223 62.3124 50.7803 62.1367 50.7506C62.0437 50.7418 61.9501 50.7418 61.8572 50.7506H61.6975L61.5378 50.7962C61.369 50.8773 61.2133 50.9832 61.0758 51.1104C60.9446 51.2303 60.8248 51.356 60.7107 51.4816C60.486 51.7407 60.2802 52.0155 60.0947 52.304C60.3571 52.0813 60.6081 51.8528 60.8704 51.6472C60.9959 51.5444 61.1271 51.4416 61.264 51.3502C61.3876 51.2617 61.5217 51.1888 61.6633 51.1332C61.7947 51.1037 61.9311 51.1037 62.0625 51.1332C62.2175 51.1712 62.3699 51.2189 62.5188 51.276C62.8268 51.3845 63.1348 51.5159 63.4257 51.6472L63.574 51.7158L63.6881 51.6015C63.9105 51.3731 64.1444 51.1503 64.3839 50.939C64.5037 50.8305 64.6235 50.7277 64.7433 50.6363L64.8345 50.5792H64.8745C64.933 50.57 64.9927 50.57 65.0513 50.5792C65.3622 50.6338 65.6676 50.7159 65.9639 50.8248C66.289 50.8819 66.597 51.0019 66.905 51.1161Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.044 49.7968C74.7621 49.3955 74.4534 49.0139 74.12 48.6545C73.786 48.2669 73.4024 47.9251 72.9792 47.6379C72.8469 47.5525 72.6999 47.4925 72.5458 47.4608C72.4948 47.4519 72.4427 47.4519 72.3918 47.4608H72.2777L72.078 47.5008C71.8157 47.5636 71.5761 47.6436 71.3366 47.7235C70.8631 47.8949 70.4126 48.1005 69.9563 48.2947L70.3441 48.3575C69.9713 47.9947 69.575 47.657 69.1577 47.3466C68.9415 47.1914 68.7168 47.0484 68.4847 46.9183C68.3597 46.8503 68.2301 46.7911 68.0968 46.7412C68.0246 46.7155 67.9501 46.6963 67.8744 46.6841C67.7889 46.6782 67.7032 46.6782 67.6177 46.6841C67.3419 46.7179 67.0727 46.793 66.8192 46.9068C66.5739 47.0096 66.3458 47.1296 66.1176 47.2495C65.6726 47.5025 65.2474 47.7888 64.8457 48.1062C65.3191 47.9177 65.7868 47.7235 66.2602 47.5351C66.4898 47.4479 66.724 47.3735 66.9618 47.3123C67.1799 47.2439 67.4064 47.2054 67.6348 47.1981C67.8399 47.233 68.0347 47.313 68.2052 47.4323C68.4038 47.5633 68.5943 47.7064 68.7756 47.8606C69.152 48.1633 69.5285 48.5003 69.8764 48.8373L70.0532 49.0029L70.2643 48.9001C70.692 48.683 71.1426 48.4831 71.5818 48.3004C71.7955 48.2042 72.0145 48.1203 72.2378 48.0491L72.3918 48.0091H72.4602C72.5499 48.02 72.6368 48.0471 72.7169 48.0891C73.1215 48.3168 73.5035 48.5826 73.8576 48.8829C74.2854 49.1628 74.6561 49.4826 75.044 49.7968Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.818 69.7178C172.892 69.6854 172.965 69.6531 173.039 69.6208C173.095 69.6735 173.151 69.7268 173.205 69.7807L172.818 69.7178Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.842 214.562C26.842 214.562 26.3571 212.324 25.3989 211.975C24.4407 211.627 23.8589 212.638 23.8589 212.638C23.8589 212.638 23.6308 210.49 22.2733 209.851C20.9158 209.211 19.8948 210.524 19.8948 210.524C19.8948 210.524 18.851 207.806 16.9859 207.806C15.1208 207.806 14.1854 211.804 14.1854 211.804C14.1854 211.804 13.0845 210.622 11.9552 211.29C10.8259 211.958 10.8145 214.585 10.8145 214.585L26.842 214.562Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.885 214.562C185.885 214.562 185.406 212.324 184.448 211.975C183.49 211.627 182.902 212.638 182.902 212.638C182.902 212.638 182.68 210.49 181.316 209.851C179.953 209.211 178.938 210.524 178.938 210.524C178.938 210.524 177.894 207.806 176.035 207.806C174.175 207.806 173.228 211.804 173.228 211.804C173.228 211.804 172.128 210.622 171.004 211.29C169.88 211.958 169.863 214.585 169.863 214.585L185.885 214.562Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.209 214.562H52.3545C52.3545 214.562 52.9249 212.186 54.0257 212.015C54.3615 211.985 54.6984 212.058 54.9911 212.226C55.2838 212.393 55.5182 212.647 55.6627 212.952C55.6627 212.952 55.6113 209.633 57.6989 209.068C59.7865 208.503 61.5375 211.433 61.5375 211.433C61.5375 211.433 62.8494 209.765 64.6289 209.868C66.4085 209.97 66.8648 212.723 66.8648 212.723C66.8648 212.723 68.4904 211.781 69.209 214.562Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8638 214.562H2.98877C2.98877 214.562 2.98877 213.243 3.88426 212.889C4.12138 212.787 4.38528 212.764 4.63626 212.825C4.88725 212.886 5.11174 213.026 5.27597 213.226C5.27597 213.226 5.6296 210.793 7.25517 210.793C8.88073 210.793 9.65644 212.889 9.65644 212.889C9.79433 212.689 9.98772 212.534 10.2127 212.442C10.4377 212.351 10.6845 212.328 10.9227 212.375C11.8296 212.495 11.8638 214.562 11.8638 214.562Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1678 214.562H67.3042C67.3042 214.562 67.3042 213.243 68.194 212.889C68.4311 212.787 68.695 212.764 68.946 212.825C69.197 212.886 69.4215 213.026 69.5857 213.226C69.5857 213.226 69.9393 210.793 71.5649 210.793C73.1905 210.793 73.9719 212.889 73.9719 212.889C74.1093 212.688 74.3026 212.533 74.5277 212.441C74.7529 212.35 75 212.327 75.2381 212.375C76.1336 212.495 76.1678 214.562 76.1678 214.562Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.069 214.562H213.194C213.194 214.562 213.194 213.243 214.09 212.889C214.327 212.787 214.591 212.764 214.842 212.825C215.093 212.886 215.317 213.026 215.482 213.226C215.482 213.226 215.835 210.793 217.461 210.793C219.086 210.793 219.862 212.889 219.862 212.889C220 212.689 220.193 212.534 220.418 212.442C220.643 212.351 220.89 212.328 221.128 212.375C222.035 212.495 222.069 214.562 222.069 214.562Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.994 214.562H220.387C220.387 214.562 220.421 212.386 221.858 211.804C222.249 211.639 222.683 211.606 223.094 211.709C223.505 211.812 223.872 212.046 224.14 212.375C224.14 212.375 224.71 208.377 227.402 208.377C230.094 208.377 231.395 211.832 231.395 211.832C231.622 211.502 231.941 211.246 232.312 211.094C232.683 210.943 233.09 210.904 233.483 210.981C234.954 211.147 234.994 214.562 234.994 214.562Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238 214.562H0V218.714H238V214.562Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6832 214.562C16.8843 215.236 16.9805 215.938 16.9684 216.641C16.9831 217.343 16.8868 218.043 16.6832 218.714C16.3107 217.355 16.3107 215.921 16.6832 214.562Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2892 214.562C35.6617 215.921 35.6617 217.355 35.2892 218.714C34.9088 217.357 34.9088 215.92 35.2892 214.562Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8888 214.562C54.0899 215.236 54.1861 215.938 54.174 216.641C54.1887 217.343 54.0924 218.043 53.8888 218.714C53.5162 217.355 53.5162 215.921 53.8888 214.562Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4947 214.562C72.8751 215.92 72.8751 217.357 72.4947 218.714C72.1144 217.357 72.1144 215.92 72.4947 214.562Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0942 214.562C91.2953 215.236 91.3915 215.938 91.3794 216.641C91.394 217.343 91.2978 218.043 91.0942 218.714C90.8956 218.042 90.8014 217.342 90.8147 216.641C90.8037 215.938 90.8979 215.237 91.0942 214.562Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.7 214.562C110.081 215.92 110.081 217.357 109.7 218.714C109.32 217.357 109.32 215.92 109.7 214.562Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.3 214.562C128.501 215.236 128.597 215.938 128.585 216.641C128.6 217.343 128.503 218.043 128.3 218.714C128.101 218.042 128.007 217.342 128.02 216.641C128.009 215.938 128.103 215.237 128.3 214.562Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.905 214.562C147.286 215.92 147.286 217.357 146.905 218.714C146.525 217.357 146.525 215.92 146.905 214.562Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.505 214.562C165.706 215.236 165.803 215.938 165.791 216.641C165.805 217.343 165.709 218.043 165.505 218.714C165.307 218.042 165.213 217.342 165.226 216.641C165.215 215.938 165.309 215.237 165.505 214.562Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.111 214.562C184.491 215.92 184.491 217.357 184.111 218.714C183.731 217.357 183.731 215.92 184.111 214.562Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.711 214.562C202.912 215.236 203.008 215.938 202.996 216.641C203.011 217.343 202.914 218.043 202.711 218.714C202.512 218.042 202.418 217.342 202.431 216.641C202.42 215.938 202.515 215.237 202.711 214.562Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.305 214.562C221.686 215.92 221.686 217.357 221.305 218.714C220.925 217.357 220.925 215.92 221.305 214.562Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7627 218.714L31.0742 218.577L60.38 218.526L119.003 218.429L177.62 218.526L206.932 218.577L236.238 218.714L206.932 218.857L177.62 218.903L119.003 219L60.38 218.903L31.0742 218.851L1.7627 218.714Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M144.36 43.8348C151.347 36.838 151.347 25.494 144.36 18.4972C137.372 11.5005 126.043 11.5005 119.056 18.4972C112.068 25.494 112.068 36.838 119.056 43.8348C126.043 50.8316 137.372 50.8316 144.36 43.8348Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.705 42.435C137.92 42.435 142.959 37.39 142.959 31.1666C142.959 24.9432 137.92 19.8982 131.705 19.8982C125.49 19.8982 120.452 24.9432 120.452 31.1666C120.452 37.39 125.49 42.435 131.705 42.435Z",
    fill: "#FFC727"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_971_2889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 238,
    height: 219,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubsidiaryLgIcon);
export default __webpack_public_path__ + "static/media/subsidiary-lg-icon.31e29563ec1f6e5a5b8b389f8ee9f140.svg";
export { ForwardRef as ReactComponent };